var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 2.00104C23.3289 2.00035 23.6622 2 24 2C32.5432 2 38.2428 2.2262 41.5129 2.41508C43.5881 2.53495 45.2644 4.00604 45.5043 6.07079C45.7565 8.24064 46 11.5006 46 16C46 20.4994 45.7565 23.7594 45.5043 25.9292C45.2644 27.994 43.5837 29.4654 41.5085 29.5852C38.5 29.7588 33.4378 29.964 26 29.9958",
    stroke: "#FFCF00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9C20 9.91925 19.8189 10.8295 19.4672 11.6788C19.1154 12.5281 18.5998 13.2997 17.9497 13.9497C17.2997 14.5998 16.5281 15.1154 15.6788 15.4672C14.8295 15.8189 13.9193 16 13 16C12.0807 16 11.1705 15.8189 10.3212 15.4672C9.47194 15.1154 8.70026 14.5998 8.05025 13.9497C7.40024 13.2997 6.88463 12.5281 6.53284 11.6788C6.18106 10.8295 6 9.91925 6 9C6 8.08075 6.18106 7.1705 6.53284 6.32122C6.88463 5.47194 7.40024 4.70026 8.05025 4.05025C8.70026 3.40024 9.47194 2.88463 10.3212 2.53284C11.1705 2.18106 12.0807 2 13 2C13.9193 2 14.8295 2.18106 15.6788 2.53284C16.5281 2.88463 17.2997 3.40024 17.9497 4.05025C18.5998 4.70026 19.1154 5.47194 19.4672 6.32122C19.8189 7.1705 20 8.08075 20 9Z",
    stroke: "#FFCF00",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5747 16.2862C29.7638 16.3478 30.7962 17.1298 30.9273 18.3132C31.0122 19.0794 31.0417 20.0385 30.9097 21.1214C30.7683 22.282 29.7909 23.1164 28.636 23.2981L20.9999 24.5L19.293 42.3965C19.1203 44.2069 17.7477 45.6768 15.9362 45.8374C14.9119 45.9282 13.7332 46 12.567 46C11.5998 46 10.7045 45.9506 9.92743 45.882C8.17616 45.7273 6.90489 44.2726 6.7657 42.5201L5.99994 32.8784L4.02252 32.197C2.81224 31.7799 1.99172 30.6401 2.05167 29.3614C2.18846 26.4438 2.57629 23.6062 2.97027 21.3334C3.48486 18.3647 6.02644 16.2515 9.03736 16.1415C15.2944 15.913 22.2997 15.9612 28.5747 16.2862Z",
    stroke: "#FFCF00",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34V46",
    stroke: "#FFCF00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassLesson);
export default __webpack_public_path__ + "static/media/class-lesson.5e4a798e1ed858dc5671a84876e1a1b8.svg";
export { ForwardRef as ReactComponent };